import { render, staticRenderFns } from "./AssetDetailsComponent.vue?vue&type=template&id=402b7a95&"
import script from "./AssetDetailsComponent.vue?vue&type=script&lang=js&"
export * from "./AssetDetailsComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports